module.exports = __webpack_public_path__ + "img/zsk.27725ff9.jpg";